import React from "react";
import FaqMenu from "./FaqMenu";
import SettingsMenu from "./SettingsMenu";
import NotificationMenu from "./NotificationMenu";
import ProfileMenu from "./ProfileMenu";
import { useViewport } from "utilities/hookutils";
import { PhosphorListButton } from "components/Atoms/PhosphorIconButton";
import { isViewport } from "utilities/viewportUtils";
import { ThemeSelectMenu } from "./ThemeSelectMenu";
interface TopBarProps {
  notificationCount: number
  onMenuOpen: () => void
}

const TopBar = (props: TopBarProps) => {
  const viewportType = useViewport();

  const isSmallScreen = isViewport(viewportType).smallerThan("desktopMedium");

  return <>
    {isSmallScreen && <div className="top-bar-wrapper-placeholder" />}
    <div className="top-bar-wrapper">
      {isSmallScreen && <PhosphorListButton
        layout="in-square"
        iconSize="large"
        onClick={props.onMenuOpen}
      />}
      <span className="top-bar-middle" />
      <FaqMenu />
      <ThemeSelectMenu />
      <NotificationMenu notificationCount={props.notificationCount} />
      <SettingsMenu />
      <ProfileMenu />
    </div>
  </>;
};

export default TopBar;
